import React from "react";

import Banner from "../Component/Banner";
import { PersonInfo } from "../Component/PersonInfo";

export const Landing = () => {
  return (
    <>
      <Banner />
      <PersonInfo></PersonInfo>
    </>
  );
};
